import React from 'react';
import SbEditable from 'storyblok-react';
import GetTeam from '/src/utils/GetTeam';
import WithLargeImagesTeamMember from './WithLargeImagesTeamMember';

const orderPeopleByCustomArray = (people, orderArray) => {
  return orderArray.map((personName) =>
    people.find((person) => person.name === personName)
  );
};

const WithLargeImagesPerson = ({ blok, customOrderArray }) => {
  const people = GetTeam();
  
  const orderedPeople = orderPeopleByCustomArray(people, customOrderArray);

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className={`py-10 lg:py-15 px-6 bg-white`}>
        <div className="max-w-7xl mx-auto 2xl:max-w-screen-2xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14">
            {orderedPeople.map((person) => (
              <WithLargeImagesTeamMember {...person} key={person.uuid} />
            ))}
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default WithLargeImagesPerson;
